"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiSparklesIcon = void 0;
var react_1 = __importDefault(require("react"));
/**
 * Inline sparkles SVG used to flag AI-generated content. Rendered as an
 * inline SVG (rather than a Fabric `Icon`) so it always shows a proper
 * sparkle glyph regardless of which Fabric icon set the host app has
 * registered.
 */
exports.AiSparklesIcon = function (_a) {
    var className = _a.className, _b = _a.size, size = _b === void 0 ? 12 : _b;
    return (react_1.default.createElement("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true", focusable: "false" },
        react_1.default.createElement("path", { d: "M12 2.25l1.85 4.9 4.9 1.85-4.9 1.85L12 15.75l-1.85-4.9-4.9-1.85 4.9-1.85L12 2.25zM18.5 13.5l.9 2.4 2.4.9-2.4.9-.9 2.4-.9-2.4-2.4-.9 2.4-.9.9-2.4zM5.5 14l.7 1.85L8.05 16.55l-1.85.7L5.5 19.1l-.7-1.85L2.95 16.55l1.85-.7L5.5 14z" })));
};
